export function useZapierChatbot() {
  const SCRIPT_ID = 'zapier-chatbot'

  const route = useRoute()
  const hasScript = ref(false)

  watch(() => route.fullPath, () => {
    hasScript.value = import.meta.client && !!document.getElementById(SCRIPT_ID)
  }, { immediate: true })

  const isPathAllowed = (path: string) => {
    const config = useRuntimeConfig()
    return config.public.zapier.whitelist.includes(path)
  }

  const injectScript = () => {
    const config = useRuntimeConfig()

    if (!document?.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.src = config.public.zapier.chatbotSrc
      script.type = 'module'
      script.async = true
      document.head.appendChild(script)
    }
  }

  const removeScript = () => {
    const script = document?.getElementById(SCRIPT_ID)
    if (script) script.remove()
  }

  return { injectScript, hasScript, isPathAllowed, removeScript }
}
